<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="body Part">
<p id="rw-p_110264-00001"><a id="pb-rw_1">
</a></p><a id="pb-rw_1">
</a><div class="title-block" id="rw-title-block_110264-00001"><a id="pb-rw_1">
</a><h1><a id="pb-rw_1"></a><a href="#/9781847674951_tableofcontents">SIR WALTER SCOTT BAR<sup>T</sup><br/> of <br/> Abbotsford<br/> HIS. GURNAL<sup>*</sup><br/> Vol. I.
            </a></h1>
</div>
<div class="block epigraph" id="rw-block-epigraph_110264-00001">
<p class="fp">As I walked by myself <br/> I talkd to my self
            </p>
<p>And thus my self said to me.</p>
<p style="text-align: right;">Old Song.</p>
</div>
<p class="fp" id="rw-fp_110264-00001">A hard word so spelld on Authority of Miss Scott now Mrs. Lockhart.</p>
<p><a id="pb-rw_2">
</a></p><a id="pb-rw_2">
</a></div><a id="pb-rw_2">
</a></div><a id="pb-rw_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847674951_part_01.vue?779dbe88